import { cast, types } from 'mobx-state-tree';
import { createThunk, model, Model } from 'mst-collection';

import { Api, IReportReasonTypeResponse } from '@api';
import { ReasonTypeModel } from './ReasonTypeModel';

export class Report extends Model({
  reasonTypes: types.array(ReasonTypeModel),
}) {
  get selectedReasonTypeIds() {
    return this.reasonTypes
      .filter((t) => t.isSelected)
      .map((t) => t.reasonTypeId);
  }

  get hasSelectedReasons() {
    return this.selectedReasonTypeIds.length > 0;
  }

  setReasonTypes(values: IReportReasonTypeResponse[]) {
    this.reasonTypes = cast(values);
  }

  fetchReasonTypes = createThunk(() => {
    return async function fetchTypes(this: Report) {
      const res = await Api.Reports.getReasonTypes();

      this.setReasonTypes(res.data);
    };
  });
}

export const ReportModel = model(Report);
